<template>
  <el-select
    size="mini"
    placeholder="Filtrar por soport de venta"
    v-bind:value="supportSeller"
    filterable
    clearable
    @change="handleChange"
    v-bind="$attrs"
  >
    <el-option
      v-for="(seller, index) in supportSellerList"
      :key="index"
      :value="seller.value"
      :label="seller.label"
    >
      <el-avatar
        v-if="seller.image"
        style="float: left"
        size="small"
        :src="seller.image"
      ></el-avatar>
      <el-avatar
        v-else
        style="float: left"
        size="small"
        src="/static/images/avatar-2.jpg"
      ></el-avatar>
      <span style="padding-left: 5px; color: #8492a6; font-size: 12px">{{
        seller.label
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: "supportSeller",
    event: "change"
  },
  props: {
    supportSeller: {
      type: Number,
      required: false,
      default: null
    },
    byUser: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    supportSellerList() {
      var sellersupport;
      if (this.byUser) {
        sellersupport =
          this.$store.getters["support_sellers/getSupportSellerSelector"];
        //console.log("support_sellers: ", sellersupport)
        return sellersupport;
      }
      sellersupport =
        this.$store.getters["support_sellers/getSupportSellersEmployee"];
      //console.log("employesssupport_sellers: ", sellersupport)
      return sellersupport;
    }
  },
  methods: {
    handleChange(val) {
      this.$emit("change", val);
    }
  }
};
</script>

<style></style>
